const PackageRecommendation = ({ results, currentPhase }) => {
  if (currentPhase !== 'complete' || results.downloadSpeed >= 50) return null;

  return (
    <div className="glass-card rounded-2xl p-6 border border-orange-500/30 dark:border-orange-400/30">
      <h3 className="font-bold text-lg mb-3 text-orange-500 dark:text-orange-400">Upgrade Recommendation</h3>
      <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
        Your current speed might be limiting. Consider upgrading for better performance.
      </p>
      <button className="w-full px-4 py-2 bg-orange-500 hover:bg-orange-600 dark:bg-orange-600 dark:hover:bg-orange-700 rounded-lg transition-colors text-sm font-medium text-white">
        View Packages
      </button>
    </div>
  );
};
export default PackageRecommendation;